import { useCurrentUser } from '@cma/app'
import { useMemo } from 'react'
import { usePlatformClient } from '../usePlatformClient'

export interface FontOption {
  key: string
  value: string
  url?: string | null
}

const FALLBACK_FONTS: FontOption[] = [
  {
    key: 'bitter',
    value: 'Bitter',
    url: 'https://fonts.googleapis.com/css?family=Bitter'
  },
  {
    key: 'cabin',
    value: 'Cabin',
    url: 'https://fonts.googleapis.com/css?family=Cabin'
  },
  {
    key: 'catamaran',
    value: 'Catamaran',
    url: 'https://fonts.googleapis.com/css?family=Catamaran'
  },
  {
    key: 'lato',
    value: 'Lato',
    url: 'https://fonts.googleapis.com/css?family=Lato'
  },
  {
    key: 'lora',
    value: 'Lora',
    url: 'https://fonts.googleapis.com/css?family=Lora'
  },
  {
    key: 'montserrat',
    value: 'Montserrat',
    url: 'https://fonts.googleapis.com/css?family=Montserrat'
  },
  {
    key: 'open_sans',
    value: 'Open Sans',
    url: 'https://fonts.googleapis.com/css?family=Open Sans'
  },
  {
    key: 'raleway',
    value: 'Raleway',
    url: 'https://fonts.googleapis.com/css?family=Raleway'
  },
  {
    key: 'roboto',
    value: 'Roboto',
    url: 'https://fonts.googleapis.com/css?family=Roboto'
  }
]

export function useFontOptions(): FontOption[] {
  const { data: { currentUser } = {} } = useCurrentUser()
  const { data: { platformClient } = {} } = usePlatformClient({
    id: currentUser?.account?.id || ''
  })

  return useMemo(() => {
    const platformFonts = platformClient?.defaultFonts

    if (platformFonts && platformFonts.length > 0) {
      return platformFonts
    }

    return FALLBACK_FONTS
  }, [platformClient?.defaultFonts])
}
